import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UseArchiveInconsistencies {
  inconsistencyIds: string[];
  caseId: string;
}

export const useArchiveInconsistencies = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ inconsistencyIds, caseId }: UseArchiveInconsistencies) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { inconsistencyIds },
      });

      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/inconsistency/archive`, fetchConfig);

      if (!response.ok) {
        throw new Error('Failed to archive inconsistencies');
      }
    },
    onSuccess: (_, { caseId, inconsistencyIds }) => {
      const count = inconsistencyIds.length;
      toast.success(`Successfully archived ${count} inconsistenc${count === 1 ? 'y' : 'ies'}`);
      queryClient.invalidateQueries({ queryKey: [QueryEntity.CaseInconsistencies, { caseId }] });
    },
    onError: () => {
      toast.error('Failed to archive inconsistencies');
    },
  });
};
